<template>
  <card>
    <list
      v-if="$store.state.user.sections['insurance_orders']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
    <h4 v-else>{{ "no_acccess" | setText("НЕТ ДОСТУПА") }}</h4>
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "role",
      fields: [
        // {
        //   label: "Выберите услугу",
        //   key: "service",
        //   labelKey: "select_service",
        //   type: "select",
        //   modal: "service",
        //   selectKey: "name",
        // },
        {
          col: " col-12 col-md-12",
          key: "type",
          label: "Тип страховки",
          labelKey: "insurance_type",
          type: "static_radio",
          default: "smartphone",
          items: [
            { id: "smartphone", title: "Смартфоны", titleKey: "smartphones" },
            // { id: "car", title: "Авто", titleKey: "cars" },
          ],
        },
        {
          col: "col-12 col-md-6",
          label: "Номер телефона покупателя",
          key: "phone",
          labelKey: "client_phone",
          type: "mask",
          mask: "+998#########",
          default: "+998",
        },
        {
          col: "col-12 col-md-6",
          label: "Имя покупателя",
          key: "first_name",
          labelKey: "client_first_name",
          type: "field",
        },
        {
          col: "col-12 col-md-6",
          label: "Фамилия покупателя",
          key: "last_name",
          labelKey: "client_last_name",
          type: "field",
        },
        {
          col: "col-12 col-md-6",
          label: "Отчество",
          key: "family_name",
          labelKey: "family_name",
          type: "field",
        },
        {
          col: "col-12 col-md-6",
          label: "ПИНФЛ",
          key: "PINFL",
          labelKey: "PINFL",
          type: "field",
          info: 2,
        },
        {
          col: "col-12 col-md-6",
          label: "Номер паспорта",
          key: "passport_number",
          labelKey: "passport_number",
          type: "field",
        },
        {
          col: "col-12 col-md-12",
          label: "Адрес прописки в паспорте",
          key: "passport_address",
          labelKey: "passport_address",
          type: "field",
        },
        {
          col: "col-12 col-md-6",
          label: "Дата рождения",
          key: "birthday",
          labelKey: "birthday",
          type: "field",
          textType: "date",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_insurance_order",
      itemLink: "insurance_orders",
      setLink: "insurance_orders",
      columns: [
        {
          key: "id",
          title: "ID",
          titleKey: "id",
        },
        {
          key: "exchange_id",
          titleKey: "exchange_id",
          title: "ID партнера",
          full: true,
        },
        {
          key: "price",
          titleKey: "price",
          title: "Цена",
          full: true,
          price: true,
        },
        {
          key: "user",
          titleKey: "employee",
          title: "Оператор",
          object: "name",
          disableLink: true,
        },
        {
          key: "service",
          titleKey: "service",
          title: "Услуга",
          object: "name",
          disableLink: true,
        },
        {
          key: "client",
          titleKey: "client",
          title: "Покупатель",
          object: "phone",
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
